import React, {
    createContext,
    FunctionComponent,
    useContext,
    useMemo,
} from 'react';
import { ExperimentMap } from '../../types';

export const OVERRIDE_KEY = 'overrideStatsigServerEnroll';

const SSRExperimentsContext = createContext<ExperimentMap>({});

interface SSRExperimentProviderProps {
    experiments?: ExperimentMap;
    location?: Location;
}

export const SSRExperimentsProvider: FunctionComponent<
    SSRExperimentProviderProps
> = ({ experiments, location, children }) => {
    const experimentsWithOverrides = useMemo(() => {
        const overrides = getExperimentOverrideFromUrl(location?.search);
        return {
            ...experiments,
            ...overrides,
        };
    }, [experiments, location]);

    return (
        <SSRExperimentsContext.Provider value={experimentsWithOverrides}>
            {children}
        </SSRExperimentsContext.Provider>
    );
};

function getExperimentOverrideFromUrl(url?: string): ExperimentMap {
    const overrides = new URLSearchParams(url || '');

    if (!overrides || !overrides.has(OVERRIDE_KEY)) {
        return {};
    }

    const [experimentName, key, val] =
        overrides.get(OVERRIDE_KEY)?.split(':') || [];

    return {
        [experimentName]: { [key]: val },
    };
}

export function useSSRExperiment<T>(
    experiment: string,
    param: string,
    defaultValue: T,
) {
    const experimentContext = useContext(SSRExperimentsContext);

    return (experimentContext?.[experiment]?.[param] as T) || defaultValue;
}
